//Package imports
import axios from 'axios';
import React, {useRef, useState} from 'react'
import { Button, FormGroup, Form, Card, Alert, Row, Col, Container} from "react-bootstrap";
import Cookies from 'universal-cookie'
import { useHistory } from 'react-router-dom';

//URL imports
import { getS3StaticFile, uploadFilePath, UniversitiesPath } from './urls';

const cookies = new Cookies();

const UploadCSV = () => {

  const history = useHistory();
  const [file, setFile] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [successResponse, setSuccessResponse] = useState();

  // Required to have a reference to the form to reset the file input
  const inputForm = useRef(null);

  const handleFile = (event) => {
    event.preventDefault();
  
    const fileToUpload = event.target.files[0];
    setFile(fileToUpload)
  };
  
  const handleSubmitData = (event) => {
    event.preventDefault();
    setLoading(true);
    setError(false);
    setSuccessResponse(null);
  
    let formData = new FormData();
    let source = "partner-dashboard-bulk";
    formData.append("file", file);
    formData.append("source", source)
    
    if(file && file.name.split('.').pop() == 'csv' && file.size < 102400){
      let auth_token = cookies.get('auth_token')
      axios
      .post(uploadFilePath , formData, {headers:{'Authorization':`Bearer ${auth_token}`, 'Content-Type':'text/csv'}})
      .then((response) => {
        setSuccessResponse(response.data);
        if (inputForm) {
          inputForm.current.reset();
        }
        setFile(null);
      })
      .catch((error) => {
        setError(error.response.data.message || 'Something is Wrong')
      })
      .finally(() => {
        setLoading(false); 
      });
    } else {
      setLoading(false);
      setError('Please choose a csv file and file size should be less than 100kb')
    }
  };

  const handleDownloadCSV = (content,filename) => {
    const blob = new Blob([content], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const getUniversities = () => {
    let auth_token = cookies.get('auth_token');
    axios
        .get(UniversitiesPath, {
            headers: {
                Authorization: `Bearer ${auth_token}`,
            },
            responseType: 'text'
        })
        .then(response => {
            handleDownloadCSV(response.data.uni_csv_content,'Universities.csv');
        })
        .catch(error => {
            console.error('Error fetching universities:', error);
        });
  };

  const styles = { margin: '20px', borderRadius: '10px', boxShadow: '-1px 4px 20px -6px rgba(0, 0, 0, 0.75)'}

  return (
    <>
      <Card style={styles}>
        <Container>
          <Card.Body>
            <Card.Title>Upload File</Card.Title>
            <Card.Text style={{ lineHeight: "1.75" }}>
              <h6 style={{ fontWeight: "bold", marginBottom:"0.75rem" }}>Please read the following instructions carefully before uploading the file: </h6>
              <li>File type must be <b>.csv</b> only</li>
              <li>Following columns must be present in the file with corresponding values in each column - <code>name</code>, <code>email</code>, <code>phone</code>, <code>university</code>, <code>budget</code>, <code>lease</code>, <code>city</code>, <code>movein</code> (YYYY-MM-DD), <code>comments</code></li>
              <li>Name, Email, Phone, University, and City fields are Mandatory.</li>
              <li>File size should not be greater than <b>100KB</b></li>
              <li>The Phone no. must be with the country code <b>(like - +918502892661)</b></li>
              <li>
                Make sure <b>University</b> is from the list : 
                <a href='javascript:void(0)' onClick={getUniversities}>
                  Universities List
                </a>
              </li>
              <li>For <b>budget</b> and <b>lease</b> please keep only <b>number in pounds per week</b></li>
              <li>For <b>move-in</b> please use a proper date format <b>(like - YYYY-MM-DD)</b></li>
              <li>The <b>number of rows</b> in the CSV file must be less than or equal to <b>100</b></li>
              <a href={getS3StaticFile('uniacco-sample-v2.csv')}>Download the sample csv</a>
            </Card.Text>
            <form ref={inputForm}>
              <div>
                <input type='file' onChange={handleFile} />
              </div>
              <Button onClick={handleSubmitData} className='mt-3'>
              {loading ? 'Uploading...' : 'Submit'}
              </Button>
            </form>
            {successResponse ?(
              <div>
                File has been submitted
                {successResponse.csv_content ? (
                  <div className='alert alert-warning'>
                    <li>{successResponse.resp}</li>
                    <li>
                      Please find attached CSV file for Unprocessed leads.
                      Reason for unprocessed leads are mentioned in the CSV.
                    </li>
                    <Button onClick={()=>handleDownloadCSV(successResponse.csv_content,'Unprocessed_leads.csv')} style={{ marginTop: '1rem' }}>
                      Download CSV
                    </Button>
                  </div>
                ) : (
                  <div className='alert alert-success'>
                    <li>{successResponse.resp}</li>
                  </div>
                )}
              </div>
            ):(<div>{error}</div>)
            } 
          </Card.Body>
        </Container>
      </Card>
    </>
  );
  }
  
  export default UploadCSV;
  